module.exports = __webpack_public_path__ + "static/media/g_Vector.2b3bf2ef.svg";